<template>
    <nav class="ml-5 hidden items-center space-x-7 lg:flex xl:ml-10">
        <HeaderDropdown
            label="Продукция"
            dropdown-class="container w-full rounded-20 left-0 xl:top-[calc(100%_+_1.5px)] top-[calc(100%_-_1px)]"
            chevron-left
            chevron-right
            :is-open="openMenu === 'products'"
            @close="closeMenu"
            @open="openProductMenuHandler">
            <HeaderProductionsList
                class="max-xl:pb-6 max-xl:pt-4 xl:px-4 xl:pb-6"
                @close="closeMenuImmediately" />
        </HeaderDropdown>
        <HeaderNavItem to="/rent"> Аренда</HeaderNavItem>
        <HeaderNavItem to="/portfolio"> Портфолио</HeaderNavItem>
        <HeaderDropdown
            label="Про Cromi"
            dropdown-class="-left-4 top-[calc(100%_+_2rem)] xl:top-[calc(100%_+_2.3rem)] rounded-20 rounded-tl-none"
            chevron-right
            :is-open="openMenu === 'proCromi'"
            class="relative"
            @close="closeMenu"
            @open="openProCromiMenuHandler">
            <!-- class="absolute -left-4 top-[3.5rem] overflow-hidden rounded-20 rounded-tl-none bg-white opacity-0 transition-all duration-300"> -->

            <HeaderLinkList
                :items="proCromiList"
                @close="closeMenuImmediately" />
        </HeaderDropdown>

        <HeaderNavItem to="/contacts"> Контакты</HeaderNavItem>
    </nav>
</template>

<script lang="ts" setup>
import HeaderDropdown from '~/components/layouts/header/HeaderDropdown.vue'
import HeaderLinkList from '~/components/layouts/header/HeaderLinkList.vue'
import HeaderNavItem from '~/components/layouts/header/HeaderNavItem.vue'
import HeaderProductionsList from '~/components/layouts/header/HeaderProductionsList.vue'
import type { IHeaderLinkItem } from '~/components/layouts/header/header.types'

type Timeout = ReturnType<typeof setTimeout>

const proCromiList: IHeaderLinkItem[] = [
    {
        title: 'О компании',
        icon: 'logo',
        link: '/about',
    },
    {
        title: 'Доставка и оплата',
        icon: 'car',
        link: '/delivery-and-payment',
    },
    {
        title: 'Гарантии и сервис',
        icon: 'wrench',
        link: '/warranty-and-service',
    },
    {
        title: 'Отзывы',
        icon: 'star',
        link: '/reviews',
    },
    {
        title: 'СМИ о нас',
        icon: 'tv',
        link: '/media',
    },
    {
        title: 'Новости',
        icon: 'news',
        link: '/news',
    },
    {
        title: 'Вопрос-ответ',
        icon: 'question',
        link: '/faq',
    },
    {
        title: 'Видео',
        icon: 'video',
        link: '/videos',
    },
    {
        title: 'Блог PRO',
        icon: 'note',
        link: '/pro',
    },
]

const openTimer = ref<null | Timeout>(null)
const closeTimer = ref<null | Timeout>(null)
const OPEN_TIMEOUT = 150
const CLOSE_TIMEOUT = 150
const closeMenuTimeout = ref<null | Timeout>(null)
const openMenu: Ref<null | 'products' | 'proCromi' | 'solutions'> = ref(null)

const openProductMenuHandler = () => {
    if (closeTimer.value) clearTimeout(closeTimer.value)

    openTimer.value = setTimeout(() => {
        openMenuHandler('products')
    }, OPEN_TIMEOUT)
}

const openProCromiMenuHandler = () => {
    if (closeTimer.value) clearTimeout(closeTimer.value)

    openTimer.value = setTimeout(() => {
        openMenuHandler('proCromi')
    }, OPEN_TIMEOUT)
}

const closeMenu = () => {
    if (openTimer.value) clearTimeout(openTimer.value)

    closeTimer.value = setTimeout(() => {
        openMenu.value = null
    }, CLOSE_TIMEOUT)
}

function openMenuHandler(menu: 'products' | 'proCromi' | 'solutions') {
    if (closeMenuTimeout.value) {
        clearTimeout(closeMenuTimeout.value)
        closeMenuTimeout.value = null
    }

    openMenu.value = menu
}

function closeMenuImmediately(): void {
    queueMicrotask(() => {
        closeMenu()
    })
}

onBeforeUnmount(() => {
    if (openTimer.value) clearTimeout(openTimer.value)
    if (closeTimer.value) clearTimeout(closeTimer.value)
})

// useSchemaOrg([
//     defineItemList({
//         name: 'Основная навигация',
//         itemListElement: proCromiList.map((item) => {
//             return defineListItem({
//                 '@type': ['SiteNavigationElement', 'Webpage'],
//                 name: item.title,
//                 url: item.link.endsWith('/') ? item.link : item.link + '/',
//             })
//         }),
//     }),
// ])
</script>
